/*
 * Copyright (c) 2021 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {SessionTimeout} from '@ion/dls/src/notifications/SessionTimeout';
import {sessionTimeout} from '@/store/actions/login';
import {ApplicationState} from '@/store/reducers';

/**
 * The SessionExpired component provides the top-level session timeout UI within
 * the Application.
 */
export const SessionExpired = () => {
  const dispatch  = useDispatch();
  const isSessionTimeout = useSelector(({errors}: ApplicationState) => errors.error?.isUnauthorizedError);
  if (isSessionTimeout) {
    return (
      <SessionTimeout show onLogin={function() {
        dispatch(sessionTimeout());
      }} />
    );
  }
  return null;
};
export default SessionExpired;
